import React from 'react';
interface AppButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  variant?: 'primary' | 'secondary' | 'ghost' | 'danger' | 'outline';
  size?: 'sm' | 'md' | 'lg';
  icon?: React.ReactNode;
  iconPosition?: 'left' | 'right';
  fullWidth?: boolean;
}
export function AppButton({
  children,
  variant = 'primary',
  size = 'md',
  icon,
  iconPosition = 'left',
  fullWidth = false,
  className = '',
  disabled,
  ...props
}: AppButtonProps) {
  const baseClasses = 'inline-flex items-center justify-center font-medium transition-all duration-200 focus:outline-none disabled:opacity-35 disabled:cursor-not-allowed';
  const variantClasses: Record<ButtonVariant, string> = {
    primary: 'bg-[#8eff01] text-black font-semibold hover:bg-[#a0ff33] active:bg-[#7de000] shadow-[0_0_20px_rgba(142,255,1,0.15)] hover:shadow-[0_0_28px_rgba(142,255,1,0.25)]',
    secondary: 'bg-white/[0.04] text-white border border-white/[0.08] hover:bg-white/[0.06] hover:border-white/[0.12]',
    ghost: 'text-white/60 hover:text-white hover:bg-white/[0.04]',
    danger: 'bg-red-500/10 text-red-400 border border-red-500/20 hover:bg-red-500/20',
    outline: 'bg-transparent text-white border border-white/[0.08] hover:bg-white/[0.04]'
  };
  const sizeClasses: Record<ButtonSize, string> = {
    sm: 'px-3 py-1.5 text-xs rounded-lg',
    md: 'px-5 py-2.5 text-sm rounded-xl',
    lg: 'px-6 py-3 text-base rounded-xl'
  };
  return <button className={`${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${fullWidth ? 'w-full' : ''} ${className}`} disabled={disabled} {...props} data-id="element-43">
      {icon && iconPosition === 'left' && <span className="mr-2 opacity-60" data-id="element-44">{icon}</span>}
      {children}
      {icon && iconPosition === 'right' && <span className="ml-2 opacity-60" data-id="element-45">{icon}</span>}
    </button>;
}